export const DnDTypes = {
  FOUND_IMAGE: 'FOUND_IMAGE'
}

export const SearchActionTypes = {
  SEARCH_REQUEST: 'SEARCH_REQUEST',
  SEARCH_RESPONSE: 'SEARCH_RESPONSE',
  SEARCH_ERROR: 'SEARCH_ERROR',
  SEARCH_SWITCH: 'SEARCH_SWITCH'
}

export const AcfActionTypes = {
  IMAGE_RECEIVE: 'IMAGE_RECEIVE',
  IMAGE_CANCEL: 'IMAGE_CANCEL',
  IMAGE_UPLOADING: 'IMAGE_UPLOADING',
  IMAGE_UPLOAD_COMPLETED: 'IMAGE_UPLOAD_COMPLETED'
}



/** WEBPACK FOOTER **
 ** ./src/js/constants/Constants.js
 **/